import React, { PureComponent } from 'react';
import {
  string, func, shape, object,
} from 'prop-types';
import omit from 'lodash/omit';
import noop from 'lodash/noop';
import { connect } from 'react-redux';
import IFrame from '../../../../../IFrame';
import pubSubInstance from '../../../../../../../shared/utils/pubSub';
import { endpoints } from '../../../../../../../store/services/common/logTrack/logTrackApi';

const DEFAULT_MESSAGE = {
  dataType: 'trigger_payment_iframe',
};

export class CreditCardIFrame extends PureComponent {
  static propsTypes = {
    creditCardInfo: shape({
      creditCardIFrameUrl: string,
    }),
    locale: string.isRequired,
    billingContact: object,
    logTrack: func,
  }

  static defaultProps = {
    creditCardInfo: {},
    logTrack: noop,
  }

  constructor(props) {
    super(props);
    const {
      creditCardInfo: { creditCardIFrameUrl }, locale,
    } = props;
    this.state = {
      src: creditCardIFrameUrl ? `${creditCardIFrameUrl}&locale=${locale}` : '',
      isPciReady: false,
    };
  }

  componentDidMount() {
    const { widgetNameSpace } = this.props;
    pubSubInstance.subscribe(`${widgetNameSpace}-payment-item-validate`, this.handleValidate);
    pubSubInstance.subscribe(`${widgetNameSpace}-payment-item-submit`, this.handleSubmit);
  }

  componentWillUnmount() {
    const { widgetNameSpace } = this.props;
    pubSubInstance.unsubscribe(`${widgetNameSpace}-payment-item-validate`, this.handleValidate);
    pubSubInstance.unsubscribe(`${widgetNameSpace}-payment-item-submit`, this.handleSubmit);
  }

  handleValidate = () => {
    const { src: dataSourceUrl, isPciReady } = this.state;
    return new Promise((resolve) => {
      if (dataSourceUrl) {
        if (!isPciReady) {
          resolve(false);
          return;
        }
        this.validate = (result) => {
          resolve(result);
        };
        this.iframe?.postMessage({
          dataSourceUrl, dataType: 'trigger_validate_iframe',
        });
      } else {
        resolve(true); // iframe not render case
      }
    });
  }

  handleSubmit = async () => {
    const { src: dataSourceUrl } = this.state;
    const { logTrack } = this.props;
    const {
      creditCardInfo: { creditCardIFrameUrl }, locale, billingContact,
    } = this.props;
    return new Promise((resolve) => {
      if (dataSourceUrl) {
        this.commit = (result) => {
          const { errorCode } = result;
          resolve({ ...result, paymentMethodType: 'CREDIT_CARD' });
          if (errorCode === 'ERROR_SAVE_CARD_FAILED') {
          // reload iframe to solve session id expired after 1 hour issue
            this.setState({ src: '' }, () => {
              this.setState({ src: creditCardIFrameUrl ? `${creditCardIFrameUrl}&locale=${locale}` : '' });
            });
          }
          if (errorCode) {
            logTrack?.({
              params: {
                message: `creditCard create ams acount failed: ${errorCode}`,
              },
            });
          }
        };
        this.iframe?.postMessage({ dataSourceUrl, dataContent: { billingInfo: billingContact } });
      } else {
        resolve({ status: true, paymentMethodType: 'CREDIT_CARD' }); // iframe not render case
      }
    });
  }

  listener = ({ dataSource, dataType, dataContent } = {}) => {
    if (dataSource === 'payment-method-service') {
      if (dataType === 'height_adjustment') {
        const { height, width } = dataContent || {};
        this.setState({ height, width });
      } else if (dataType === 'trigger_payment_iframe') {
        const { sessionId, result, ...rest } = dataContent;
        const status = result && typeof result === 'string'
          && result.toUpperCase().indexOf('SUCCESS') !== -1;
        this.commit && this.commit({ paymentAccountId: sessionId, status, ...rest });
      } else if (dataType === 'trigger_validate_iframe') {
        const { result } = dataContent;
        this.validate && this.validate(result);
      } else if (dataType === 'pci_ready') { // check pci ready
        this.setState({ isPciReady: true });
      }
    }
  }

  render() {
    const { src, width } = this.state;
    if (src) {
      return (
        <IFrame
          className="cui-mg-t-20"
          data-testid="credit-card-iframe"
          src={src}
          origin={src}
          title="PCICreditCard"
          {...omit(this.state, [ 'src' ])}
          ref={(i) => { this.iframe = i; }}
          listener={this.listener}
          defaultMessage={DEFAULT_MESSAGE}
          frameBorder="0"
          scrolling="no"
          width={width || '100%'}/>
      );
    }
    return null;
  }
}

const mapState = state => ({
  creditCardInfo: state.paymentMethods.entities.paymentMethods.creditCardInfo,
  billingContact: state.paymentMethods.billingContact,
  locale: state.propsData.locale,
  widgetNameSpace: state.propsData.widgetNameSpace,
});

const mapDispatch = (dispatch) => {
  return {
    logTrack: params => dispatch(endpoints.logTrack.initiate(params)),
  };
};

const connector = connect(mapState, mapDispatch);

export default connector(CreditCardIFrame);
